import { nextTick } from "vue"
import { createI18n } from "vue-i18n"
import LanguageUtils from "../utils/languages"

// All locale files are bundled up front (as the webpack dynamic require did),
// which keeps loading synchronous. Keys look like "../locales/views/home/en.js".
const localeModules = import.meta.glob("../locales/**/*.js", {
  eager: true,
  import: "default"
})

let languagesLoaded = []

export function setI18nLanguage(i18n, locale) {
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale
  } else {
    i18n.global.locale.value = locale
  }
  document.querySelector("html").setAttribute("lang", locale)
  loadLocaleMessages(i18n, locale)
}

export async function loadLocaleMessages(i18n, locale) {
  loadLanguageFiles(i18n, locale)
  return nextTick()
}

export function loadLanguageFiles(i18n, langCode) {
  loadLanguageFilesFromPath(
    i18n,
    [
      "",
      "views/documents",
      "views/downloads",
      "views/home",
      "views/tenants",
      "views/machines",
      "views/users",
      "views/reports",
      "views/fleetAnalytics"
    ],
    langCode
  )
}

export function loadLanguageFilesFromPath(i18n, paths, langCode) {
  let loadLanguage = (langCode, path) => {
    if (!languagesLoaded.includes(`${langCode}-${path}`)) {
      const translations =
        localeModules[`../locales/${path ? path + "/" : ""}${langCode}.js`]
      i18n.global.mergeLocaleMessage(langCode, translations)
      languagesLoaded.push(`${langCode}-${path}`)
    }
  }
  langCode = langCode || i18n.global.locale.value?.substring(0, 2)
  const fallbackLangCode =
    i18n.global.fallbackLocale.value?.substring(0, 2) ||
    LanguageUtils.defaultLang().code
  for (var i = 0; i < paths.length; i++) {
    loadLanguage(langCode, paths[i])
    if (langCode != fallbackLangCode) {
      loadLanguage(fallbackLangCode, paths[i]) //Fallback language loaded in case when there is missing translation for specific item
    }
  }
}

function setupI18n(
  options = {
    legacy: false,
    locale: "en",
    fallbackLocale: "en",
    // Some messages contain HTML (e.g. <strong>, <br/>) and are shown with
    // v-html. The messages are bundled from locale files in this repo, so they
    // are trusted. vue-i18n v8 did not warn about HTML in messages, but v9
    // does by default, so it is turned off to keep the previous behaviour.
    warnHtmlMessage: false
  }
) {
  const i18n = createI18n(options)
  // Also loads the fallback language (en) at startup
  setI18nLanguage(i18n, options.locale)
  return i18n
}

export const i18n = setupI18n()
